module.exports = __webpack_public_path__ + "img/dustbin.695639f7.svg";